var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showWarning)?_c('u-message',{staticClass:"has-margin-y-100",attrs:{"icon":"exclamation-circle","type":"is-warning","title":_vm.$t('_sentence.affiliate.customer_controls_disabled_title')}},[_c('i18n',{attrs:{"path":"_sentence.affiliate.customer_controls_disabled_desc"}}),_vm._v(" "),_c('u-link',{attrs:{"slot":"action","icon-right":"arrow-right","to":{
      name: 'adminDynamicSettings',
      params: {
        settingId: 'affiliate_systems'
      }
    }},slot:"action"},[_c('i18n',{attrs:{"path":"_sentence.affiliate.customer_controls_disabled_link"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }